<template>
    <div class="rr-builder-block-container" :style="block.styleBackgroundRow" :class="block.blockPaddingTopClass + ' ' + block.blockPaddingBottomClass">
        <div :class="{ 'uk-container': block.blockWrap}">
            <div class="rr-builder-block-nav">
                <a @click="showEditBlockModal" class="rr-builder-block-nav__button"><i class="fal fa-cog"></i></a>
                <a @click="moveUpBlock" class="rr-builder-block-nav__button"><i class="fal fa-chevron-up"></i></a>
                <a @click="moveDownBlock" class="rr-builder-block-nav__button"><i class="fal fa-chevron-down"></i></a>
                <a @click="cloneBlock" class="rr-builder-block-nav__button"><i class="fal fa-clone"></i></a>
                <a @click="removeBlock" class="rr-builder-block-nav__button"><i class="fal fa-trash"></i></a>
                <span class="rr-builder-block-nav__label">#{{ index+1 }}</span>
            </div>
            <div :style="block.styleBlockWrapper">
              <div class="rr-builder-block-wrapper"
                   :class="{'rr-builder-block-wrapper_flex-middle': block.blockValign==='middle', 'rr-builder-block-wrapper_flex-bottom': block.blockValign==='bottom','rr-builder-block-wrapper_reverse': block.blockReverse, 'rr-builder-block-wrapper_collapse': block.blockCollapse, 'rr-builder-block-wrapper_hidden-small': block.blockHiddenSmall}"
                   :style="block.styleBlock">
                <builder-editable-content :content="block.content" :index="index" ref="editor"> </builder-editable-content>
              </div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import (reference) "~less/app";
    @import "~rubinred/content/less/rubinred-builder";

    /* nav */
    .rr-builder-block-nav {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: @builder-default-background;

        &__button {
            color: @builder-font-contrast-color;
            font-size: @builder-font-size;
            line-height: 1;
            background-color: @builder-default-background;
            padding: 6px 10px;
            transition: background-color 0.3s ease;

            &:hover,
            &:focus {
                color: @builder-font-contrast-color;
                background-color: @builder-default-background-hover;
            }
        }

        &__label {
            margin-left: auto;
            background-color: tint(@builder-default-background, 30%);
            color: @builder-font-contrast-color;
            font-size: @builder-font-size;
            line-height: 1;
            padding: 6px 10px;
        }
    }
    /* block wrapper */
    .rr-builder-block-wrapper{
        &_reverse {
            .uk-grid {
                flex-direction: row-reverse;
            }
        }
        &_collapse{
            .uk-grid{
                margin-left: 0;
                > * {
                    padding-left: 0;
                }
            }
        }
        &_flex{
            &-middle{
                .uk-grid{
                    .uk-flex-middle
                }
            }
            &-bottom{
                .uk-grid{
                    .uk-flex-bottom
                }
            }
        }
        &_hidden-small{
            @media (max-width: @breakpoint-small-max){
                display: none;
            }
        }
    }
    .rr-builder-container .rr-builder-block-container {
        > div[style*="border-radius"] {
            overflow: hidden;
        }
    }
    /* embed video width */
    .rr-builder-block-wrapper [data-oembed-url],
    .rr-builder-block__media [data-oembed-url],
    .rr-builder-block__content [data-oembed-url]{
        [data-oembed-url]  > div {
            max-width: 100% !important;
        }
    }
    /* blocks */
    .rr-builder-block {

        /* media */
        .rr-builder-block__media:not(:last-child) {
            margin-bottom: 15px;
        }

        &.rr-builder-block_one-col .rr-builder-block__media:not(:last-child) {
            margin-bottom: 30px;
        }

        /* padded text */
        &.rr-builder-block_padded-text .rr-builder-block__content {
            @media (min-width: @breakpoint-medium) {
                padding: @grid-gutter-horizontal*2;
            }

            @media (min-width: @breakpoint-large) {
                padding: @grid-gutter-horizontal-l*2;
            }
        }

        /* divider */
        &.rr-builder-block_divider {
            .rr-builder-block_divider-hr {
                display: block;
                border-top: 1px solid @global-border;
            }
        }
    }
</style>

<script>
  import PrimaryLocaleAwareComponent from "rubinred/content/js/mixins/PrimaryLocaleAwareComponent";

  export default {
    mixins: [PrimaryLocaleAwareComponent],
    props: ['block', 'index'],

    methods: {
      removeBlock() {
        window.App.UIkit.modal.confirm("<h3>" + this.$t('rubinred.content.builder.messages.delete_item_confirm_title', this.primaryLocale) + "</h3><p>" + this.$t('rubinred.content.builder.messages.delete_item_confirm_text', this.primaryLocale) + "</p>", {
          labels: {
            ok: this.$t('rubinred.content.builder.messages.delete', this.primaryLocale),
            cancel: this.$t('rubinred.content.builder.messages.cancel', this.primaryLocale)
          }
        }).then(() => {
          this.$root.$emit('remove-block', this.index);
        });
      },

      cloneBlock() {
        window.App.UIkit.notification(this.$t('rubinred.content.builder.messages.item_duplicated', this.primaryLocale), {status: 'success', pos: 'top-center'});
        this.$root.$emit('clone-block', this.index);
      },

      moveUpBlock() {
        this.$root.$emit('move-up-block', this.index);
      },

      moveDownBlock() {
        this.$root.$emit('move-down-block', this.index);
      },

      showEditBlockModal() {
        this.$root.$emit('open-edit-block-modal', {block: this.block, index: this.index});
      },
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/content/assets/js/components/BuilderBlock.vue